import { create } from "zustand"

/**
 * UI state for the questionnaire Version History panel. The version data itself is fetched
 * on demand by the panel (read-only), so this store only tracks open/closed state — mirroring
 * the UI-state slice of commentsStore.
 */
interface HistoryStore {
  isPanelOpen: boolean
  openPanel: () => void
  closePanel: () => void
  togglePanel: () => void
}

export const useHistoryStore = create<HistoryStore>((set) => ({
  isPanelOpen: false,
  openPanel: () => set({ isPanelOpen: true }),
  closePanel: () => set({ isPanelOpen: false }),
  togglePanel: () => set((state) => ({ isPanelOpen: !state.isPanelOpen })),
}))
